/** 台账工坊 — 设计令牌（Ant Design 6） */
export const LEDGER = {
  paper: '#faf7f2',
  paperDim: '#f0ebe3',
  ink: '#1a1a1a',
  line: '#2c2c2c',
  accent: '#2d5a3d',
  accentMuted: '#ebe6dc',
  mono: '"JetBrains Mono", "Consolas", monospace',
  sans: '"Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif',
}

export const appTheme = {
  token: {
    colorPrimary: LEDGER.accent,
    colorSuccess: '#3b6d11',
    colorWarning: '#854f0b',
    colorError: '#a32d2d',
    colorInfo: LEDGER.accent,
    colorBgLayout: LEDGER.paperDim,
    colorBgContainer: LEDGER.paper,
    colorBgElevated: LEDGER.paper,
    colorBorder: LEDGER.line,
    colorBorderSecondary: '#c4bdb0',
    colorText: LEDGER.ink,
    colorTextSecondary: '#4a4a4a',
    colorTextTertiary: '#6b6b6b',
    borderRadius: 2,
    borderRadiusLG: 2,
    borderRadiusSM: 2,
    fontFamily: LEDGER.sans,
    fontFamilyCode: LEDGER.mono,
    lineWidth: 2,
    controlOutlineWidth: 0,
    boxShadow: 'none',
    boxShadowSecondary: 'none',
    boxShadowTertiary: 'none',
  },
  components: {
    Layout: {
      siderBg: LEDGER.paper,
      headerBg: LEDGER.paper,
      bodyBg: LEDGER.paperDim,
      triggerBg: LEDGER.paper,
    },
    Menu: {
      itemBorderRadius: 0,
      itemMarginInline: 0,
      itemMarginBlock: 0,
      itemHeight: 44,
      activeBarBorderWidth: 3,
      activeBarWidth: 3,
      itemSelectedBg: '#ebe6dc',
      itemSelectedColor: LEDGER.ink,
      itemHoverBg: '#f5f0e8',
    },
    Card: {
      boxShadow: 'none',
      boxShadowTertiary: 'none',
      borderRadiusLG: 2,
      paddingLG: 16,
    },
    Table: {
      headerBg: LEDGER.accentMuted,
      headerColor: LEDGER.ink,
      borderColor: LEDGER.line,
      rowHoverBg: '#f5f0e8',
    },
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      borderRadius: 2,
    },
    Modal: {
      borderRadiusLG: 2,
      boxShadow: 'none',
    },
    Drawer: {
      borderRadiusLG: 0,
    },
    Input: {
      borderRadius: 2,
      activeShadow: 'none',
    },
    Select: {
      borderRadius: 2,
    },
    Tag: {
      borderRadiusSM: 2,
    },
    Statistic: {
      titleFontSize: 12,
    },
  },
}

/** 角色色（线框/头像，非蓝紫） */
export const ROLE_COLORS = {
  admin: LEDGER.accent,
  store_admin: '#3f5a8a',
  staff: '#5c4a32',
}
